import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	TABLET_BP,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	img {
		height: 60px;
	}
`;
export const Description = styled.div`
	font-family: var(--ff-haffer-xh);
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	font-stretch: normal;
	font-style: normal;
	line-height: 1.69;
	& a {
		color: ${({ linkColor = "#551A8B" }) => linkColor};
	}
`;

export const Title = styled.h3`
	font-family: var(--ff-haffer-xh);
	font-size: 20px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 2.25;
	margin-top: 10px;
	margin-bottom: 15px;

	@media only screen and (max-width: ${TABLET_BP}px) {
		font-size: 18px;
		line-height: 1.5;
	}
`;
